import { ActivityBuilderPrintStaticImage } from 'approot/activity-builder/print/activity-builder-print-image';
import { ViewProps } from './image.constants';
import {
  ImageContainer,
  ImageFillWrapper,
  ImageViewWrapper,
} from './image.style';
import { useImageDimensionEffect } from 'approot/shared/images/images.hooks';
import { computePaddingTop } from '../shared/component-height/component-dimension.utils';
import { getPrintImage } from '../shared/logic/get-print-image';
import {
  ComponentHeightWrapper,
  ComponentInnerWrapper,
} from '../shared/component-height/component-dimensions.style';
import { ComponentCaption } from '../shared/component-caption/component-caption';

type baseProps = {
  imageUrl: string;
  altText?: string | null;
};

export const ImageViewFit = ({ imageUrl, altText }: baseProps) => {
  const { imageDimensions, setContainerElement } = useImageDimensionEffect({
    imageUrl,
  });
  return (
    <ImageViewWrapper ref={setContainerElement}>
      <ActivityBuilderPrintStaticImage
        imageUrl={imageUrl}
        imageDimensions={imageDimensions}
        altText={altText || ''}
      />
    </ImageViewWrapper>
  );
};

export const ImageViewFill = ({ imageUrl, altText }: baseProps) => {
  return (
    <ImageFillWrapper>
      <ActivityBuilderPrintStaticImage
        imageUrl={imageUrl}
        altText={altText || ''}
      />
    </ImageFillWrapper>
  );
};

const ImagePrint = ({
  id,
  stimulusResourceProperties,
  properties: {
    showCaptionOnLesson,
    imageUrls,
    dimensionData,
    cropData,
    caption,
    altText,
  },
}: ViewProps) => {
  const isFit = !cropData;
  const imageUrl = getPrintImage(imageUrls);
  const imageAltText = stimulusResourceProperties?.altText || altText;

  return (
    <ComponentHeightWrapper
      style={{
        paddingTop: `${computePaddingTop(dimensionData)}%`,
      }}
    >
      <ComponentInnerWrapper>
        <ImageContainer $fullBorderRadius={!showCaptionOnLesson}>
          {isFit ? (
            <ImageViewFit imageUrl={imageUrl} altText={imageAltText} />
          ) : (
            <ImageViewFill imageUrl={imageUrl} altText={imageAltText} />
          )}
        </ImageContainer>
        <ComponentCaption
          id={id}
          caption={caption}
          showCaption={showCaptionOnLesson}
        />
      </ComponentInnerWrapper>
    </ComponentHeightWrapper>
  );
};
export default ImagePrint;
